module.exports = __webpack_public_path__ + "static/diy_recipe_bio_bird_feeder-adaf24b4657dda8866fbfa6f8ff4ea16.pdf";